import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'

const swall = withReactContent(Swal)

export const showMessageHtml = (title, html, icon, function_confirmation) => {
    swall.fire({
        title,
        html,
        icon,
        footer: "©" + new Date().getFullYear() + " CSJ Sistemas"
    }).then(() => function_confirmation?.());
};

export const showMessage = (title, text, icon, function_confirmation) => {
    swall.fire({
        title: title,
        text: text,
        icon: icon,
        footer: "©" + new Date().getFullYear() + " CSJ Sistemas"
    }).then(() => {
        if (function_confirmation !== null)
            function_confirmation();
    })
};

export const showQuestion = (title, text, icon, function_confirmation) => {
    swall.fire({
        title: title,
        text: text,
        icon: icon,
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Confirmar',
        cancelButtonText: 'Cancelar',
    }).then((result) => {
        if (result.value) {
            if (function_confirmation !== null)
                function_confirmation(true);
        }
        else {
            function_confirmation(false);
        }
    })
};